<template>
    <div id="cardBody" class=" currentShowColor" :class="!isMobile?'lightTheme bigRoundAngles bigShadow':'navTheme'" :style="styleObject">
      <transition name="fade" mode="out-in">
        <episode-card v-if="appStep === states.MENU" :key="appStep"></episode-card>

        <watch-card v-else-if="appStep === states.WATCH_CARD"
                    :synopsis="currentEpisodeData.synopsis.french!=''&&profile.datas.estimated_level<3?currentEpisodeData.synopsis.french:currentEpisodeData.synopsis.sentence"
                    :words-list="gameWordsList.vocab"
                    :wordsLoaded="gameWordsList.loaded"
                    :netflixId="currentEpisodeData.netflix_id"
                    :title="currentEpisodeData.english_title" :key="appStep"></watch-card>

        <session-card :key="appStep" v-else></session-card>
      </transition>

      <!--
      - appstep => states.onGoingSession when click on "study again"
      -->
    </div>
</template>

<script>

	import {mapGetters, mapActions} from 'vuex'

	export default {
    name: "card",
    components: {
      WatchCard: () => import(/* webpackPrefetch: true */ '@/components/watchCard.vue'),
      SessionCard: () => import(/* webpackPrefetch: true */ '@/components/sessionCard.vue'),
      EpisodeCard: () => import(/* webpackPrefetch: true */ '@/components/episodeCard.vue')
    },
    created: function () {

    },
    computed: {
      ...mapGetters('global', [
        'isMobile', 'routeParams',
        'routeName',
        'appStep',
        'states',
        'profile'
      ]),
      ...mapGetters('show', [
        'currentShow',
        'currentSeason',
          'currentEpisodeData'
      ]),
      ...mapGetters('game', [
        'gameWordsList',
      ]),
      styleObject: function () {
        if(this.currentShow.hue != undefined)
        {
          return {
            '--hue': this.currentShow.hue,
          }
        }
        else {
          return {
            '--hue': 330,
          }
        }

      },
    },
    methods: {
      ...mapActions('global', [
        'set_appStep',
      ]),
      ...mapActions('show', [
        'set_currentShow',
        'set_currentShowLoaded',
        'set_currentEpisodeData'
      ]),
      selectShowEpisode: function () {
        this.set_currentEpisodeData(this.currentSeason.episodes[this.episode]);
      },
    },
    data: function () {
      return {
        season: 0,
        episode: 0,
      }
    }
  }
</script>

<style scoped>

  #cardBody {
    display: flex;
    align-self: center;
    justify-self: center;
    overflow: hidden;
    z-index: 1;
    height: 32vw;
    min-height: 32vw;
    max-height: 32vw;
    /*max-width: calc(min(900px, 50vw));*/
    max-width: 60vw;
    width: 60vw;
    min-width: 60vw;
  }

  /*/////////////////////////// Theme ///////////////////////////////////////*/
  .currentShowColor {
    --lightColor: hsla(var(--hue), 100%, 96%, 1);
    --lightplainColor: hsla(var(--hue), 100%, 70%, 1);
    --darkColor: hsla(var(--hue), 100%, 5%, 1);
    --plainColor: hsla(var(--hue), 90%, 25%, 1);
    --lightGrey: hsla(var(--hue), 10%, 80%, 1);
  }

  @media screen and (max-device-width: 767px) {
    #cardBody {
      min-height: 100%;
      height: 100%;
      max-height: 100%;
      max-width: 100%;
      width: 100%;
      min-width: 100%;
      overflow-y: auto;
    }


  }

</style>
